import { z } from 'zod';
export const VendorSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    code: z.string().min(1).max(32),
    nameTh: z.string().min(1),
    // Thai tax IDs are 13 digits; foreign vendors may have other formats so the
    // raw column allows any string. We don't tighten here — coordinator can layer
    // a stricter rule at the API edge per use case.
    taxId: z.string().nullable().optional(),
    // M2-c: Vendor IS the transactable BRANCH under a Supplier parent.
    supplierId: z.uuid(),
    branchCode: z.string().default('00000'),
    branchName: z.string().nullable().optional(),
    addressTh: z.string().nullable().optional(),
    addressJson: z.unknown().nullable().optional(),
    defaultExpenseCode: z.string().nullable().optional(),
    defaultDepartmentId: z.uuid().nullable().optional(),
    vatClaimRequiresOriginal: z.boolean().optional(),
    country: z.string().min(2).max(2),
    // free-text payment terms ('N30', 'N45', 'COD', ...)
    terms: z.string().nullable().optional(),
    // AP Phase C1 — structured successor to the free `terms` hint. References a
    // per-company PaymentTerm.code; when set + resolvable, createBill derives the
    // bill's dueDate + discount-window snapshot from that master term.
    defaultPaymentTermCode: z.string().nullable().optional(),
    email: z.email().nullable().optional(),
    // FK-by-value to Currency.code (ISO 4217 3-letter)
    currency: z
        .string()
        .length(3)
        .regex(/^[A-Z]{3}$/),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateVendorSchema = VendorSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateVendorSchema = CreateVendorSchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=vendor.js.map